/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: bbqin
 * @LastEditTime: 2022-03-15 15:53:35
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginCollapse from 'bee-collapse';

import { Collapse as OriginCollapse } from '@tinper/next-ui';

//require('bee-collapse/build/Collapse.css');
require('./index.less');
export default class Collapse extends Component {
    render() {
        let { expanded, bodyClassName, useOrigin, ...others } = this.props;
        if (useOrigin) {
            return <OriginCollapse {...this.props} />;
        }
        return <OriginCollapse.Panel expanded={expanded || this.props.in} {...others} bodyClassName={`${bodyClassName} base-collapse-body`} />;
    }
}

Collapse.Panel = OriginCollapse.Panel;